import React from "react";
import SurveyEntry from '../platformui/SurveyEntry';

export default (props) => (
  <SurveyEntry {...props} />
);